import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    const errorObj = {
      forceReport : true,
      errorMsg : error.message,
      reactInfo : info,
      stack : error.stack,
    }
    reportError( errorObj )
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return ( 
        <p>
          The element failed to render properly...
        </p>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary